import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { InventoryProvider } from './context/InventoryContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import CompanyDetails from './pages/CompanyDetails';
import DeviceInventory from './pages/DeviceInventory';
import SimInventory from './pages/SimInventory';
import VehicleDetails from './pages/VehicleDetails';
import Layout from './components/Layout';
import PrivateRoute from './components/PrivateRoute';
import AdminSignup from './pages/AdminSignup';
import SubCompany from './pages/SubCompany';
import InstallerSignup from './pages/InstallerSignup';
import LogPage from './pages/LogPage';
import Reports from './pages/Reports';
import DeviceReports from './pages/DeviceReports';
import InstallerReports from './pages/InstallerReports';
import { ToastContainer } from 'react-toastify'; 
import TeamLeadSignup from './pages/TeamLeadSignup';
import 'react-toastify/dist/ReactToastify.css'; 

function App() {
  return (
    <AuthProvider>
      <InventoryProvider>
        <BrowserRouter>
          <ToastContainer />
          <Routes>
            {/* 1. Public Login Route */}
            <Route path="/login" element={<Login />} />
            {/* 3. Protected App Routes (With Layout) */}
            <Route element={<PrivateRoute />}>
              <Route element={<Layout />}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/admin-signup" element={<AdminSignup />} />
                <Route path="/sub-companies" element={<SubCompany />} />
                <Route path="/company-details" element={<CompanyDetails />} />
                <Route path="/device-inventory" element={<DeviceInventory />} />
                <Route path="/sim-inventory" element={<SimInventory />} />
                <Route path="/vehicle-details" element={<VehicleDetails />} />
                <Route path="/installer-signup" element={<InstallerSignup />} />
                <Route path="/log-page" element={<LogPage />} />
                <Route path="/reports" element={<Reports />} />
                <Route path="/team-lead-signup" element={<TeamLeadSignup />} />
                <Route path="/device-reports" element={<DeviceReports />} />
                <Route path="/installer-reports" element={<InstallerReports />} />
                <Route path="/" element={<Navigate to="/company-details" replace />} />
              </Route>
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </InventoryProvider>
    </AuthProvider>
  );
}
export default App;